import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17.392",
  height: "18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M.909 9.909h14.114L8.5 16.432a.91.91 0 1 0 1.273 1.3l6.818-6.818a2.7 2.7 0 0 0 0-3.841l-6.8-6.8a.92.92 0 0 0-1.3 1.3l6.523 6.523H.909a.909.909 0 1 0 0 1.818Z",
      "data-name": "Path 1628"
    }, null, -1)
  ])))
}
export default { render: render }